<template>
	<div id="shangx">

		<div class="fflex ffbet" style="align-items: center">
			<ul class="fflex headBox">
				<li @click="jump('shanglei')">商品类型</li>
				<li @click="jump('gongys')">供应商</li>
				<li @click="jump('shangx')">商品信息</li>
				<li class="active">物流设置</li>
				<li @click="jump('churukl')">出入库类型</li>
				<li @click="jump('rizhi')">日志列表</li>
			</ul>
			<div class="sousuok">
				<el-input size="mini" placeholder="物流名称查询" v-model="gyshang" @keyup.enter.native="searchname" style="border: 1px solid gainsboro;">
					<i class="el-icon-search el-input__icon" slot="suffix" v-on:click="searchname">
					</i>
				</el-input>
			</div>
		</div>

		<div class="fflex ffend" style="margin: 10px 0;line-height: 32px;color: #999;align-items: center">



			<el-input size="small" placeholder="输入物流公司名称" v-model="wuliu" style="width: 150px;margin-right: 10px"
			 @keyup.enter.native="addwl"></el-input>
			<el-button type="success" round size="mini" class="purBtnsz" @click="addwl">添加物流</el-button>

		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>物流公司名称</th>
						<th>创建时间</th>
						<th>操作</th>



					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}} </td>
						<td>
							<span v-if="tableindex!=taindex+1"> {{ta.express_name}}</span>
							<el-input size="mini" v-model="ta.express_name" style="width: 100px;" v-if="tableindex==taindex+1"></el-input>
							<el-button type="success" round size="mini" class="purBtnsz" v-if="tableindex==taindex+1" @click="baocun(ta.id,ta.express_name)">保存</el-button>
						</td>
						<td>{{ta.create_time}}</td>




						<td>
							<span class="tablebtnBox">
								<el-button type="success" @click="xiubtn(taindex)" round size="mini" class="purBtnsz">修改</el-button>
								<!--<div class="shenziBtn-mini" @click="tan(3)" >修改</div>-->
								<el-button type="success" @click="shanchu(ta.id)" round size="mini" style="background: rgb(255, 121, 124);color: #fff;border: none">删除</el-button>
								<!--<div class="qianziBtn-mini" @click="delfn(1)" style="background: rgb(255, 121, 124);color: #fff"  >删除</div>-->
							</span>
						</td>

					</tr>

				</tbody>
			</table>

		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>







	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				shangxt: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				//            shangphone:''
				goodsleiop: [{
					value: '',
					label: '请选择'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				goodslei: '',


				tabledata: '',
				//这个数据需要重置
				tableindex: 0,
				wuliu: ''


			};
		},
		methods: {
			xiubtn: function(taindex) {
				if (this.tableindex == taindex + 1) {
					this.tableindex = 0
				} else {
					this.tableindex = taindex + 1
				}

			},
			shanchu: function(id) {

				let self = this;
				self.$confirm('确认要删除此信息吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcExpress/delete',
						dataType: 'json',
						data: {
							id: id,
							token: self.token
						},
						success: function(data) {

							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: '删除成功!'
								});

								self.gonggong()

							} else {
								self.$message({
									type: 'error',
									message: '删除失败!'
								});
							}

						}
					})

				}).catch(() => {


				});





			},
			baocun: function(id, express_name) {
				let self = this;
				self.$confirm('确认要修改吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcExpress/update',
						dataType: 'json',
						data: {
							token: self.token,
							id: id,
							name: express_name
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: '修改成功!'
								});
								self.gonggong()
							} else {
								self.$message({
									type: 'error',
									message: data.msg
								});
							}

						}
					})

				}).catch(() => {
					self.gonggong()

				});

			},
			upimg: function() {
				let self = this;
				$('#img_upload').click()


			},
			gonggong: function() {
				let self = this;
				self.tableindex = 0
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcExpress/index',
					dataType: 'json',
					data: {
						page: self.currentpage,
						pageone: self.pageone,
						token: self.token,
						search: self.gyshang
					},
					success: function(data) {

						self.tabledata = data.data;
						self.total = Number(data.map.count)



					}
				})

			},
			fn: function(e) {
				this.ylimg = URL.createObjectURL(e.currentTarget.files[0])

			},
			addwl: function() {

				//            wuliu
				let self = this;
				if (!self.wuliu) {
					self.$message({
						type: 'error',
						message: '物流名称不能为空'
					});
					return;
				}
				this.$confirm('确定添加新物流公司吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					//这里请求ajax

					$.ajax({
						url: process.env.apiUrl + 'saas/JxcExpress/store',
						type: 'post',
						data: {
							token: self.token,
							name: self.wuliu
						},
						dataType: 'json',
						success: function(data) {

							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: data.msg
								});
								self.wuliu = '';
								self.gonggong()
							} else {
								self.$message({
									type: 'error',
									message: data.msg
								});
							}

						}
					})


				}).catch(() => {

				});




			},

			handleCurrentChange: function(i) {
				let self = this;
				self.currentpage = i;
				self.gonggong()
			},
			searchname: function() {
				let self = this;
				self.gonggong()
			},
			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},



		},
		mounted: function() {
			var self = this;
			self.token = $.cookie('token');

			$.ajax({
				url: process.env.apiUrl + 'saas/JxcExpress/index',
				type: 'post',
				data: {
					token: self.token
				},
				dataType: 'json',
				success: function(data) {

					self.tabledata = data.data;
					self.total = Number(data.map.count);



				}

			})



		}


	}
</script>

<style scoped>
	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.yulantu {
		width: 100px;
		height: 100px;
		border-radius: 6px;
		margin-left: 10px;
	}

	ul {
		list-style: none;
	}

	#shangx p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#shangx * {
		box-sizing: border-box;
	}

	#shangx {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #8CBB77;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #8CBB77 !important;
		height: 26px;
		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/wuliu.vue